import React from "react";

const IconShare = props => {
    let { icon } = props;

    return (
        <a
            className="icon-share react-share ui_share"
            href="#"
            onClick={props.showModal.bind(null, null, "ICON_SHARE", {
                icon
            })}
        />
    );
};

export default IconShare;
